import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { TimeSlotSelectorPage } from './time-slot-selector.page';

const routes: Routes = [
  {
    path: '',
    component: TimeSlotSelectorPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TimeSlotSelectorPageRoutingModule {}
